import { render, staticRenderFns } from "./WorkoutDetail.vue?vue&type=template&id=22ec99a2&scoped=true"
import script from "./WorkoutDetail.vue?vue&type=script&lang=js"
export * from "./WorkoutDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkoutDetail.vue?vue&type=style&index=0&id=22ec99a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec99a2",
  null
  
)

export default component.exports